import React, { useEffect, useState } from 'react'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import {
    mapData,
    dateFormatFunction,
} from '../../../../product/common/components'
import './CustomSearch.css'
import { Button, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import RadioBox from '@/product/components/atoms/RadioBox'

const CustomSearch = (props) => {
    const { onProceedClick, isPayoutEnabled } = props

    const [searchInfo, setSearchInfo] = useState(null)
    const [additionalFilter, setAdditionalFilter] = useState({})
    const [condition, setCondition] = useState(false)
    const formik = props.formik
    const [anchorEl, setAnchorEl] = React.useState(null)
    const { t } = useTranslation()
    const [reload, setReload] = useState(false)
    const handleSubmit = (e) => {
        formik.values.page = 1
        if (props.makePayment && props.pluginName) {
            props.makePaymentFn(props.pluginName)
        } else {
            formik.handleSubmit(e)
        }
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const resetFunction = () => {
        props.resetForm()
        formik.handleSubmit()
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'adv-popover' : undefined
    useEffect(() => {
        setCondition(false)
        if (props.advFilters) {
            if (props.searchInfo.data && props.searchInfo.data?.length) {
                let searchMapData = props.searchInfo?.data
                let addData = props.searchInfo?.data
                let searching = searchMapData.filter(
                    (data, index) => index === 0
                )
                let addFilter = addData.filter((data, index) => index !== 0)
                let finalSearch = {
                    formik: props.searchInfo.formik,
                    data: searching,
                }
                let finalFilter = {
                    formik: props.searchInfo.formik,
                    data: addFilter,
                }
                setSearchInfo(finalSearch)

                setAdditionalFilter(finalFilter)
                setCondition(true)
            } else if (props.searchInfo.length) {
                let searchMapData = props.searchInfo
                let addData = props.searchInfo
                let searching = searchMapData.filter(
                    (data, index) => index === 0
                )
                let addFilter = addData.filter((data, index) => index !== 0)
                let finalSearch = {
                    formik: formik,
                    data: searching,
                }
                let finalFilter = {
                    formik: formik,
                    data: addFilter,
                }
                setSearchInfo(finalSearch)

                setAdditionalFilter(finalFilter)
                setCondition(true)
            }
        } else if (props.searchInfo) {
            setSearchInfo(props.searchInfo)
            setCondition(true)
        }
    }, [props.searchInfo, props.advFilters])

    const applyFunction = () => {
        formik.values.page = 1
        formik.handleSubmit()
        setAnchorEl(null)
    }
    //Date Time Filters added
    const today = new Date()
    const currentYear = today.getFullYear()
    const allSearchOptions = [
        { id: 'within', description: 'Within' },
        { id: 'customSelection', description: 'Custom Selection' },
    ]
    const withinRange = [
        {
            label: t('Within'),
            placeholder: t('Enter Within'),
            class: 'col-4',
            type: 'select',
            options: [
                { value: 'day', show: t('The Past Day') },
                { value: 'week', show: t('The Past Week') },
                { value: 'month', show: t('The Past Month') },
                { value: 'year', show: t('The Past Year') },
            ],
            name: 'within',
            formik: formik,
        },
    ]
    const dateRange = {
        formik: formik,
        data: [
            {
                label: t('Select Type'),
                placeholder: t('Select Type'),
                class: 'col-4',
                type: 'select',
                name: 'select_type',
                options: [
                    { value: 'single_date', show: t('Date') },
                    { value: 'date', show: t('Date Range') },
                    { value: 'yearly', show: t('Yearly') },
                    { value: 'quarterly', show: t('Quarterly') },
                    { value: 'monthly', show: t('Monthly') },
                ],
            },
            {
                label: t('Select Quarter'),
                placeholder: t('Select Quarter'),
                class: ` ${
                    formik.values?.select_type === 'quarterly' ? '' : 'd-none'
                } col-4 `,
                type: 'select',
                name: 'quarterly',
                options: [
                    { value: 'q1', show: t('Q1') },
                    { value: 'q2', show: t('Q2') },
                    { value: 'q3', show: t('Q3') },
                    { value: 'q4', show: t('Q4') },
                ],
            },
            {
                label: t('Select Month'),
                placeholder: t('Select Month'),
                class: ` ${
                    formik.values?.select_type === 'monthly' ? '' : 'd-none'
                } col-4 `,
                type: 'select',
                name: 'month',
                options: [
                    { value: '', show: t('Select Month') },
                    { value: '01', show: 'January' },
                    { value: '02', show: 'February' },
                    { value: '03', show: 'March' },
                    { value: '04', show: 'April' },
                    { value: '05', show: 'May' },
                    { value: '06', show: 'June' },
                    { value: '07', show: 'July' },
                    { value: '08', show: 'August' },
                    { value: '09', show: 'September' },
                    { value: '10', show: 'October' },
                    { value: '11', show: 'November' },
                    { value: '12', show: 'December' },
                ],
            },
            {
                label: t('Select Year'),
                placeholder: t('Select Year'),
                class: ` ${
                    formik.values?.select_type === 'monthly' ||
                    formik.values?.select_type === 'yearly' ||
                    formik.values?.select_type === 'quarterly'
                        ? ''
                        : 'd-none'
                } col-4 `,
                type: 'select',
                disabled: formik.values?.month !== '' ? false : true,
                name: 'year',
                options: [
                    { value: '', show: t('Select Year') },
                    { value: `${currentYear}`, show: `${currentYear}` },
                    {
                        value: `${currentYear - 1}`,
                        show: `${currentYear - 1}`,
                    },
                    {
                        value: `${currentYear - 2}`,
                        show: `${currentYear - 2}`,
                    },
                    {
                        value: `${currentYear - 3}`,
                        show: `${currentYear - 3}`,
                    },
                    {
                        value: `${currentYear - 4}`,
                        show: `${currentYear - 4}`,
                    },
                    {
                        value: `${currentYear - 5}`,
                        show: `${currentYear - 5}`,
                    },
                ],
            },
            {
                label: t('Date'),
                placeholder: t('Enter Date'),
                type: 'date',
                class: `customDateReport ${
                    formik.values?.select_type === 'single_date' ? '' : 'd-none'
                } col-4 `,
                name: 'single_date',
                disableFuture: true,
            },
            {
                label: t('From Date'),
                placeholder: t('Enter From date'),
                type: 'date',
                class: ` ${
                    formik.values?.select_type === 'date' ? '' : 'd-none'
                } col-4 `,
                name: 'start_date',
            },
            {
                label: t('End date'),
                placeholder: t('Enter End date'),
                type: 'date',
                class: ` ${
                    formik.values?.select_type === 'date' ? '' : 'd-none'
                } col-4 `,
                name: 'end_date',
            },
        ],
    }
    useEffect(() => {
        let selectValue = formik.values?.select_type || 'yearly'
        if (props.incudeTimelineFilter) {
            if (selectValue === 'quarterly') {
                let quarterlyValue = formik.values?.quarterly
                let yearValue = formik.values?.year
                if (quarterlyValue !== '') {
                    if (!yearValue) {
                        const today = new Date()
                        const currentYear = today.getFullYear()
                        yearValue = currentYear
                    }
                    if (quarterlyValue === 'q1') {
                        formik.values.start_date = `01-01-${yearValue}`
                        formik.values.end_date = `03-31-${yearValue}`
                    } else if (quarterlyValue === 'q2') {
                        formik.values.start_date = `04-01-${yearValue}`
                        formik.values.end_date = `06-30-${yearValue}`
                    } else if (quarterlyValue === 'q3') {
                        formik.values.start_date = `07-01-${yearValue}`
                        formik.values.end_date = `09-30-${yearValue}`
                    } else if (quarterlyValue === 'q4') {
                        formik.values.start_date = `10-01-${yearValue}`
                        formik.values.end_date = `12-31-${yearValue}`
                    }
                }
            } else if (selectValue === 'yearly') {
                let yearValue = formik.values?.year || currentYear
                if (yearValue && yearValue !== '') {
                    formik.values.start_date = `01-01-${yearValue}`
                    formik.values.end_date = `12-31-${yearValue}`
                }
            } else if (selectValue === 'monthly') {
                let monthValue = formik.values?.month
                let yearValue = formik.values?.year
                if (monthValue && monthValue !== '') {
                    let month = parseInt(monthValue)
                    let finalmonth = monthValue
                    const today = new Date()
                    const currentYear = today.getFullYear()

                    const lastDay = new Date(currentYear, month, 0).getDate()
                    const endDate = new Date(
                        currentYear,
                        month - 1,
                        lastDay
                    ).getDate()

                    if (yearValue !== '') {
                        formik.values.start_date = `${finalmonth}-01-${yearValue}`
                        formik.values.end_date = `${finalmonth}-${endDate}-${yearValue}`
                    } else {
                        formik.values.start_date = `${finalmonth}-01-${currentYear}`
                        formik.values.end_date = `${finalmonth}-${endDate}-${currentYear}`
                    }
                }
            }
        }
    }, [
        formik.values?.select_type,
        formik.values?.month,
        formik.values?.year,
        formik.values?.quarterly,
    ])
    useEffect(() => {
        if (props.incudeTimelineFilter) {
            if (formik && formik.values) {
                formik.values.search = formik.values.search
                    ? formik.values.search
                    : 'customSelection'
                formik.setFieldValue('select_type', 'yearly')
                formik.setFieldValue('year', currentYear)
                // formik.values.start_date = dateFormatFunction(new Date())
                // formik.values.end_date = dateFormatFunction(new Date())

                setReload(!reload)
            }
        }
    }, [props.incudeTimelineFilter])
    return (
        <>
            {condition ? (
                props.advFilters ? (
                    <div className="commActBox d-flex justify-content-between align-items-center">
                        <div className="w-100 search-products-wrapper mb-5">
                            <form
                                onSubmit={handleSubmit}
                                className="searchFieldLt row flex-wrap d-flex  align-items-center"
                            >
                                <div className="rightContainer">
                                    {searchInfo ? mapData(searchInfo) : null}
                                    <div className="col-md-3 col-6 btnSearch custom-search">
                                        <PrimaryButton
                                            id="customSearch_submit"
                                            label={
                                                props.buttonLabel
                                                    ? props.buttonLabel
                                                    : 'search'
                                            }
                                            type="submit"
                                        />
                                    </div>
                                </div>
                                <div className="leftContainer">
                                    {isPayoutEnabled && (
                                        <Button
                                            onClick={onProceedClick}
                                            className="payout-btn"
                                        >
                                            Payout
                                        </Button>
                                    )}
                                    <div className="filter-select">
                                        <Button
                                            aria-describedby={id}
                                            variant="outlined"
                                            onClick={handleClick}
                                            className="searchPopoverBtn"
                                        >
                                            {t('Filter Options')}{' '}
                                            <span className="material-icons">
                                                expand_more
                                            </span>
                                        </Button>

                                        <Popover
                                            id={id}
                                            open={open}
                                            anchorEl={anchorEl}
                                            onClose={handleClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                        >
                                            <div className="spContent">
                                                {mapData(additionalFilter)}
                                                <div className="spAction">
                                                    <Button
                                                        onClick={() =>
                                                            resetFunction()
                                                        }
                                                        className="resetBtn"
                                                    >
                                                        {props.buttonLabel
                                                            ? props.buttonLabel
                                                            : t('Reset')}
                                                    </Button>

                                                    <Button
                                                        id="customSearch_submit"
                                                        onClick={() =>
                                                            applyFunction()
                                                        }
                                                        className="submitBtn"
                                                    >
                                                        {props.buttonLabel
                                                            ? props.buttonLabel
                                                            : t('Apply')}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Popover>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="commActBox d-flex justify-content-between align-items-center">
                            <div className="w-100 search-products-wrapper mb-5">
                                <form
                                    onSubmit={handleSubmit}
                                    className="customSearchInner row flex-wrap d-flex justify-content-start align-items-center"
                                >
                                    {searchInfo ? mapData(searchInfo) : null}

                                    {props.incudeTimelineFilter ? (
                                        <>
                                            {' '}
                                            <div className="col-4">
                                                <RadioBox
                                                    items={allSearchOptions}
                                                    value={formik.values.search}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    name="search"
                                                />
                                            </div>
                                            {formik.values.search ===
                                            'within' ? (
                                                <>
                                                    {Object.values(
                                                        mapData(withinRange)
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {Object.values(
                                                        mapData(dateRange)
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : null}

                                    {props.noSearchButton ? null : (
                                        <div className="col-auto mr-auto btnSearch px-3 mb-0">
                                            <PrimaryButton
                                                id="customSearch_submit"
                                                btnSize="medium"
                                                label={
                                                    props.buttonLabel
                                                        ? props.buttonLabel
                                                        : 'search'
                                                }
                                                type="submit"
                                            />
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : null}
        </>
    )
}

export default CustomSearch
